<template>
  <button @click.prevent="back"
          class="flex text-sm rounded-full bg-white justify-center items-center py-4 h-8" :class="'shadow-'+shadow">
    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
    </svg>
    <div class="font-bold">Retour</div>
  </button>
</template>
<script>
export default {
  name: 'back-button',
  props: ['shadow'],
  methods: {
    back() {
      window.history.go(-1);
    },
  }
}
</script>
<style lang="scss" scoped>

svg {
  @apply w-8 h-8 mr-2;
}

</style>
